import $ from "jquery";

const showroom = () => {
    if ($("#showroom-map").length) {
        if ($(".js-showroom-select").length) {
            function formatState(state) {
                if (!state.id) {
                    return state.text;
                }

                var $state = $(
                    `<span>Выбранный шоу-рум: <b>${state.text}</b></span>`,
                );

                return $state;
            }

            $(".js-showroom-select").select2({
                minimumResultsForSearch: Infinity,
                width: "100%",
                templateSelection: formatState,
            });

            $(".js-showroom-select").on("change", function (e) {
                //очищаем контент
                $("#showroom-map").html("");
                getActiveItem(
                    $(this).find("option:selected").attr("data-coords"),
                );

                $(".showroom__info .item").removeClass("active");
                $(".showroom__info .item")
                    .eq($(this).find("option:selected").index())
                    .addClass("active");

                const shopId = $(this).val();
                $(".js-brand-feedback-shop-id").val(shopId);
            });
        }

        const getActiveItem = (coords) => {
            ymaps.ready(init);

            function init() {
                // Создание карты.
                let myMap = new ymaps.Map("showroom-map", {
                    center: coords.split(","),
                    zoom: 12,
                    controls: ["zoomControl"],
                });
                myMap.behaviors.disable("scrollZoom");

                let myPlacemark = new ymaps.Placemark(
                    coords.split(","),
                    {},
                    {
                        iconLayout: "default#image",
                        iconImageHref: "/img/icons/map-mark.png",
                        iconImageSize: [55, 57],
                        iconImageOffset: [-28, -45],
                    },
                );

                myMap.geoObjects.add(myPlacemark);
            }
        };
        getActiveItem(
            $(".js-showroom-select")
                .find("option:selected")
                .attr("data-coords"),
        );
        // функция генерации контента
        // const getCityInfo = (city, response) => {
        //     const item = response.find((elem) => elem.city == city);
        //     const { map, shops } = item;

        //     // название города в скрытое поле, для обратной связи
        //     $("#city").val(item.city);

        //     // вставка магазинов
        //     shops.forEach((elem) => {
        //         // если несколько телефонов
        //         let phoneArr = elem.phone.split(",");
        //         let phones = "";
        //         if (phoneArr.length > 1) {
        //             $.each(phoneArr, function (index, value) {
        //                 phones += `<a href="tel:${value}" className="phone">${value}</a>`;
        //             });
        //         }
        //         if (phoneArr.length == 1) {
        //             phones = `<a href="tel:${elem.phone}" className="phone">${elem.phone}</a>`;
        //         }

        //         let shop = `<div class="item">
        //                 <div class="head">
        //                     <p class="name">${elem.name}</p>
        //                     <span class="type">${elem.type}</span>
        //                 </div>
        //                 <div class="content">
        //                     <p class="address">${elem.address}</p>
        //                     ${phones}
        //                     <a href="mailto:${elem.mail}" class="mail">${elem.mail}</a>
        //                     <p class="time">${elem.time}</p>
        //                 </div>
        //             </div>`;

        //         $(".contacts__list").append(shop);
        //     });

        //     //Убираем прелоадеры
        //     $(".contacts__map").removeClass("loading");
        //     $(".contacts__list").removeClass("loading");
        // };

        //Первоначальная подгрузка

        // getResource("/contacts/json").then((result) => {
        //     let activeCity = $(".tabs__item.active").text().trim();
        //     getCityInfo(activeCity, result);
        // });

        //Клик по табам
        // $(".tabs_map .tabs__item").click(function () {
        //     if (!$(this).hasClass("active")) {
        //         //Добавляем прелоадеры
        //         $(".contacts__map").addClass("loading");
        //         $(".contacts__list").addClass("loading");

        //         //очищаем контент
        //         $("#map").html("");
        //         $(".contacts__list").html("");

        //         $(this).addClass("active").siblings().removeClass("active");

        //         getResource("/contacts/json").then((result) => {
        //             let activeCity = $(".tabs__item.active").text().trim();
        //             getCityInfo(activeCity, result);
        //         });
        //     }
        // });
    }
};

export default showroom;
